module.exports = __webpack_public_path__ + "static/05-61e27781f580ead612591ea8a2843d5d.jpg";